import React from 'react'

const Skills = (props) => {
    return (
        <div className='skills'>
            {props.skills.map((skill) => {
                return (
                    <div className='skills-img'>
                        <svg
                            width="60" height="60" viewBox="0 0 250 250"
                            className="circular-progress" style={{ '--progress': skill.percent }}
                        >
                            <circle className="bg"></circle>
                            <circle className="fg"></circle>
                        </svg>
                        <img src={skill.img} alt={skill.name} />
                    </div>
                )
            })}
        </div>
    )
}

export default Skills